import { ProductVariation } from '@typings/product';

export const createProductVariation = (data: ProductVariation): ProductVariation => {
  const attributesMap = Object.fromEntries(
    // Shopify surfaces all variation values under a single 'product_group' key (unlike SFCC which uses attribute IDs)
    data.variationValues?.map(({ value }) => ['product_group', value]) ?? [],
  ) as ProductVariation['attributesMap'];

  const isOrderable = data.inventory.orderable && data.price > 0;
  const customFields = data.customFields ? JSON.parse(data.customFields) : {};
  const grillSize = customFields?.['c_grillArea (SI)'];
  return {
    ...data,
    attributesMap,
    isOrderable,
    grillSize,
  };
};
